// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"Button_btnContainer__1m6FI","fixed":"Button_fixed__15bLz","btn":"Button_btn__1iklE","disabled":"Button_disabled__3GAo5"};